import React from 'react';

import { TextButton } from '@components/Button/variants';
import { upgrade_subscription_path } from '@routes';

import TooltipStep from '../TooltipStep';

interface ProFeaturesProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const ProFeatures = ({ isProSubscriber, ...props }: ProFeaturesProps) => (
  <TooltipStep
    {...props}
    isProSubscriber={isProSubscriber}
    theme="light"
    showCloseButton={false}
    title="Pro Features"
    description="A full list of frequently updated databases and special projects."
  >
    {!isProSubscriber && (
      <TextButton
        as="link"
        href={upgrade_subscription_path()}
        className="font-suisse-screen text-byline-lg text-black"
      >
        Upgrade to Pro
      </TextButton>
    )}
  </TooltipStep>
);

export default ProFeatures;
